// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1226":"bbea4f52","4904":"431493ec"}[chunkId] + ".chunk.css";
};